import Image from 'next/image';

import SingleCharacteristic from '../SingleCharacteristic';

import styles from './index.module.scss';

export const CharacteristicsItem = ({ icon, title, values }) => {
  return (
    <div
      className={styles.singleCharacteristics}
      itemScope
      itemType='https://schema.org/ItemList'
    >
      <div className={styles.singleCharacteristics__top}>
        <div className={styles.iconHolder}>
          <Image src={icon} width={24} height={24} alt={title} title={title} />
        </div>
        <span> {title}</span>
      </div>
      <div className={styles.singleCharacteristics__bottom}>
        {values?.map((characteristicValue) => {
          return (
            <SingleCharacteristic
              key={characteristicValue?.key}
              title={characteristicValue?.key}
              value={characteristicValue?.value}
            />
          );
        })}
      </div>
    </div>
  );
};
